// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__sXhMa","title":"Images90_title__11ZnX","images":"Images90_images__3IDMU"};